export enum FeatureFlags {
  inheritNowCrossSelling = "inheritNowCrossSelling",
}
export type FeatureFlagList = {
  // frontend is not allowed to change feature flags.
  [key in FeatureFlags]: boolean;
};
